
import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import API, { auth, apikey } from '../../constants/api';
import {
	MERCHANT_FETCH,
	MERCHANT_SUMMARY_FETCH,
	CREATE_NEW_MERCHANT,
	UPDATE_MERCHANT,
	LOAD_MERCHANT,
} from '../actions';

import {
	merchantSuccess,
	merchantFail,
	merchantSummarySuccess,
	merchantSummaryFail,
	createMerchantSuccess,
	createMerchantFail,
	loadMerchantSuccess,
	loadMerchantFail,
	updateMerchantSuccess,
	updateMerchantFail,

} from './actions';

import { sortOrder } from '../../helpers/Utils';

const merchantFetchAsync = async () =>
	await API.get('/merchant', {
		headers: {
			'Content-Type': 'application/json',
			//   'userid': data.user_id,
			'apikey': apikey
		}
	})
		.then(payments => payments)
		.catch(error => error);

function* merchantFetch({ payload }) {

	try {
		const merchantFetch = yield call(merchantFetchAsync);
		if (merchantFetch.data.StatusCode === "0000") {
			const data = merchantFetch.data.ResultValues.sort(sortOrder('merchant_name'))
			yield put(merchantSuccess(data));
		} else {
			yield put(merchantFail(merchantFetch.data.Message));
		}
	} catch (error) {
		yield put(merchantFail(error));
	}
}

// const merchantSummaryFetchAsync = async () =>
//     await API.get('/merchant', {
//
//     },
//     {
//       "headers" : auth
//     })
//         .then(data => data)
//         .catch(error => error);

function* merchantSummaryFetch({ payload }) {

	try {
		const merchantSummaryFetch = yield call(merchantFetchAsync);
		if (merchantSummaryFetch.data.StatusCode === "0000") {
			const merchantCount = merchantSummaryFetch.data.ResultValues.length
			yield put(merchantSummarySuccess(merchantCount));
		} else {
			yield put(merchantSummaryFail(merchantSummaryFetch.data.Message));
		}
	} catch (error) {
		yield put(merchantSummaryFail(error));
	}
}

//* Create New Machine
const createMerchantAsync = async (req) =>
	await API.post('/merchant/' + req.actionType, {
		name: req.merchantName,
		email: req.merchantEmail,
		phone: req.merchantPhone,
		address: req.merchantAddress,
		aboutBusiness: req.merchantAbout,
		endpointUrl: req.merchantEndpoint,
		payment: req.merchantPayment,
		userId: req.createBy,
		endpointUrl: req.merchantEndpoint,
	},
		{
			headers: {
				'Content-Type': 'application/json',
				'udid': 'PJG4DNER4MHH7WI',
				'apikey': apikey,
				'action': 'ping',
				'timestamp': '1583400062'
			}
		})
		.then(data => data)
		.catch(error => error);


function* createMerchant({ payload }) {
	const { merchantCreate } = payload;

	try {
		const createMerchant = yield call(createMerchantAsync, merchantCreate);
		if (createMerchant.data.StatusCode === "0000") {
			yield put(createMerchantSuccess(createMerchant.data.ResultValues));
		} else {
			yield put(createMerchantFail(createMerchant.data.Message));
		}
	} catch (error) {
		yield put(createMerchantFail(error));
	}
}


const loadMerchantAsync = async (req) =>
	await API.get('/merchant/' + req.merchantID, {
		headers: {
			'Content-Type': 'application/json',
			//   'userid': data.user_id,
			'apikey': apikey
		}
	})
		.then(payments => payments)
		.catch(error => error);

function* loadMerchant({ payload }) {
	const { merchantLoad } = payload;
	try {

		const load = yield call(loadMerchantAsync, merchantLoad);

		if (load.data.StatusCode === "0000") {
			yield put(loadMerchantSuccess(load.data.ResultValues));
		} else {
			yield put(loadMerchantFail(load.data.Message));
		}
	} catch (error) {
		yield put(loadMerchantFail(error));
	}

}


//* Create New Machine
const updateMerchantAsync = async (req) =>
	await API.post('/merchant/' + req.actionType, {
		merchantId: req.merchantId,
		name: req.merchantName,
		email: req.merchantEmail,
		phone: req.merchantPhone,
		address: req.merchantAddress,
		aboutBusiness: req.merchantAbout,
		endpointUrl: req.merchantEndpoint,
		payment: req.merchantPayment,
		userId: req.createBy,
		endpointUrl: req.merchantEndpoint,
	},
		{
			headers: {
				'Content-Type': 'application/json',
				'udid': 'PJG4DNER4MHH7WI',
				'apikey': apikey,
				'action': 'ping',
				'timestamp': '1583400062'
			}
		})
		.then(data => data)
		.catch(error => error);

function* updateMerchant({ payload }) {
	const { merchantUpdate } = payload;

	try {
		const updateMerchant = yield call(updateMerchantAsync, merchantUpdate);
		if (updateMerchant.data.StatusCode === "0000") {
			yield put(updateMerchantSuccess(updateMerchant.data.ResultValues));
		} else {
			yield put(updateMerchantFail(updateMerchant.data.Message));
		}
	} catch (error) {
		yield put(updateMerchantFail(error));
	}
}


export function* watchMerchantFetch() {
	yield takeEvery(MERCHANT_FETCH, merchantFetch);
	yield takeEvery(MERCHANT_SUMMARY_FETCH, merchantSummaryFetch)
	yield takeEvery(CREATE_NEW_MERCHANT, createMerchant)
	yield takeEvery(LOAD_MERCHANT, loadMerchant);
	yield takeEvery(UPDATE_MERCHANT, updateMerchant)
}

export default function* rootSaga() {
	yield all([
		fork(watchMerchantFetch),
	]);
}



